<template>
  <div class="irp-field-grid" data-testid="irp-field-grid">
    <div
      v-for="(field, index) in fields"
      :key="`${field.column}_${index}`"
      class="irp-field-grid__field"
    >
      <span class="irp-field-grid__label">{{ field.name }}</span>
      <span class="irp-field-grid__value ph-no-capture dd-privacy-mask">
        {{ formatValue(field) }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DateTime } from 'luxon';

import type { RecordFieldType } from '@/types/individual_record';

const { fields } = defineProps<{
  fields: RecordFieldType[];
}>();

function formatValue({ value, data_type: dataType }: RecordFieldType) {
  if (value === null || value === undefined) return '';
  if (dataType === 'datetime' && typeof value === 'string') {
    return DateTime.fromISO(value, { setZone: true }).toFormat(
      'EEE, MMM d yyyy',
    );
  }
  return String(value);
}
</script>

<style lang="pcss" scoped>
@reference "../../../css/theme.css";

.irp-field-grid {
  @apply grid gap-x-24 gap-y-16 rounded-16 border border-neutral-border bg-white py-24 pl-24 pr-16 shadow-component;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
}

.irp-field-grid__field {
  @apply flex flex-col gap-8 min-w-0;
}

.irp-field-grid__label {
  @apply text-sm font-semibold text-neutral-text-weak truncate;
}

.irp-field-grid__value {
  @apply text-base text-neutral-text truncate;
}
</style>
